import { useNavigate } from 'react-router-dom';
import { useEventCallback } from 'record-it-components/hooks/useEventCallback';
import { RoutePaths } from '../../../classes/RoutePaths/RoutePaths';
import { useAppDispatch } from '../../../store/hooks';
import { createWorkTimeEntrySlice } from '../../../store/slice/createWorkTimeEntry/createWorkTimeEntrySlice';
import { useTodaysWorkTimeEntries } from '../../entity/workTimeEntry/useTodaysWorkTimeEntries/useTodaysWorkTimeEntries';

export function useStartCreatingWorkTimeEntryWithoutStopwatch(): UseStartCreatingWorkTimeEntryWithoutStopwatchReturnValue {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const workTimeEntries = useTodaysWorkTimeEntries();

  const startCreatingWorkTimeEntryWithoutStopwatch: StartCreatingWorkTimeEntryWithoutStopwatch =
    useEventCallback(({ userGroupId }) => {
      const lastWorkTimeEntry = workTimeEntries[workTimeEntries.length - 1];
      const currentIsoDate = new Date().toISOString();
      const startDate = lastWorkTimeEntry?.endDate ?? currentIsoDate;
      const endDate = startDate < currentIsoDate ? currentIsoDate : startDate;

      dispatch(
        createWorkTimeEntrySlice.actions.startCreation({
          startDate,
          endDate,
          breaks: [],
          note: '',
          userGroupId,
          stopwatchId: null
        })
      );
      navigate(RoutePaths.createWorkTimeEntry());
    });

  return {
    startCreatingWorkTimeEntryWithoutStopwatch
  };
}

export type UseStartCreatingWorkTimeEntryWithoutStopwatchReturnValue = {
  startCreatingWorkTimeEntryWithoutStopwatch: StartCreatingWorkTimeEntryWithoutStopwatch;
};

export type StartCreatingWorkTimeEntryWithoutStopwatch = (options: {
  userGroupId: string;
}) => void;
